import React from 'react';
import { Button, Form, Input } from 'antd';
import { CreateStudentAndAssignNewParentModel, CreateStudentDto } from 'data/manager/manager.model';
import { AddParentFormWrapper } from './user.style';
import { useSave } from '../hooks/useSave';

interface AddParentFormProps {
  useCase?: 'SchoolManager';
  studentDetails?: CreateStudentDto;
  onSetReloadAfterDrawer: Function;
  onVisibleChange: Function;
}

export const AddParentForm = (props: AddParentFormProps) => {
  const { onVisibleChange, onSetReloadAfterDrawer } = props;
  const [form] = Form.useForm();
  const { onParentSave, onCreateStudentAndAssignNewParent } = useSave();
  return (
    <AddParentFormWrapper>
      <Form form={form} name="nest-messages" layout="vertical" size="large">
        <Form.Item label="Full Name" name={'full_name'}>
          <Input />
        </Form.Item>
        <Form.Item label="Username" name={'username'}>
          <Input />
        </Form.Item>

        <Form.Item
          required={false}
          label="Email (Optional)"
          name={'email'}
          rules={[
            {
              type: 'email',
              message: 'The input is not valid E-mail!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Phone Number " name={'phone_number'}>
          <Input />
        </Form.Item>
        <Form.Item label="Password" name={'password'}>
          <Input.Password />
        </Form.Item>
        <Form.Item label="Address" name={'address'}>
          <Input />
        </Form.Item>

        <Form.Item>
          <Button
            htmlType="submit"
            onClick={() => {
              if (props.useCase === 'SchoolManager') {
                if (props.studentDetails) {
                  const payload: CreateStudentAndAssignNewParentModel = {
                    studentDetails: props.studentDetails,
                    parentDetails: { ...form.getFieldsValue() },
                  };

                  onCreateStudentAndAssignNewParent(
                    payload,
                    form,
                    props.onVisibleChange,
                    props.onSetReloadAfterDrawer,
                  );
                }
              } else {
                onParentSave(
                  { ...form.getFieldsValue() },
                  form,
                  onVisibleChange,
                  onSetReloadAfterDrawer,
                );
              }
            }}
          >
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddParentFormWrapper>
  );
};

export default AddParentForm;
